import { createContext, useState } from 'react';
import api from 'services/api';

export const WhatsappContext = createContext();

export const WhatsappProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);

  const postLogin = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post(`/Integracoes/Whatsapp/Login`, data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <WhatsappContext.Provider
      value={{
        getLoading,
        postLoading,
        postLogin,
      }}
    >
      {children}
    </WhatsappContext.Provider>
  );
};
